//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations, mapGetters } from "vuex";
import {
  conversion,
  GetItemDuration,
} from "@/tool";
import {
  userRedeem,
  inventory,
  api_SellItem,
  api_PinItem,
  api_Transfer,
  api_GetSubAccount,
  api_GetSubProfileByUid
} from "@/api";

import CustomButton from '@/partials/custom_button';
import { Modal, use_modal } from '@/components/modal';
import Picture from '@/components/picture';
import StockAward from '@/components/stockAward'
import Award from '@/components/award'
import InteractivePanel from '@/components/interactive_panel';
import Avatar from '@/components/avatar';


export default {
  data() {
    return {
      assets_list: {
        active: false,
        sortType: 0,
        sum: 0,
        current: 1,
        size: 32,
        data: {
          list: [],
        },

      },
      subAccountList: [],
      visibleSubAccount: {
        flag: false,
        uid: "",
        subProfile: null,
        searchedUid: "",
        searching: false,
      },
      phone: 'apple',
    };
  },
  components: {
    'p-custom-button': CustomButton,

    'c-modal': Modal,
    'c-picture': Picture,
    'c-stockAward': StockAward,
    'c-award': Award,
    'c-interactive-panel': InteractivePanel,
    'c-avatar': Avatar,
  },
  created() {
    this.assets_list.active = false;
    this.assets_list.data.list = [];

    this.pageAvailableData(1);
    this.setInfo();
    this.getSubAccount()

  },
  beforeDestroy() {
  },
  filters: {
    conversion,
    GetItemDuration,
  },
  methods: {
    ...mapMutations([
      "setInfo",
      "switch_tradeofferbox_show",
    ]),
    //单选
    select(obj) {
      //有取回状态或锁定状态,充值卡，交易完成的，阻止操作
      if (obj.lockType != 0)
        return;

      obj.active = !obj.active;
      this.assets_list.active = this.assets_list.data.list.every((item) => {
        return item.active;
      });
    },
    //全选/反选
    selectAll(v) {
      this.assets_list.active = !v;
      this.assets_list.data.list = this.assets_list.data.list.map(
        (item) => {
          if (item.lockType != 0 || item.isPin)
            return item;
          item.active = this.assets_list.active;
          return item;
        }
      );
    },
    //获取仓库列表
    getinventory(obj) {
      inventory(obj).then((res) => {
        if (res.data.code === 0) {
          this.assets_list.data.list = res.data.data.data;
          this.assets_list.current = res.data.data.pageNumber;
          this.assets_list.data.total = res.data.data.totalItems;
          this.assets_list.current = res.data.data.pageNumber;
        }
      });
    },
    //折现对话框
    allDiscount() {
      if (this.mynum === 0) {
        this.$toast.error("尚未选中饰品");
        return;
      }

      api_SellItem({ lstmSerial: this.activeList }).then((res) => {
        if (res.data.code === 0) {
          this.assets_list.active = false;
          this.$toast.success(res.data.msg);
          this.$store.commit("setInfo");
          this.pageAvailableData(1);

          // if(!this.isMute){
          //     this.sellSound.pause();
          //     this.sellSound.currentTime=0;
          //     this.sellSound.play();
          // }

        } else {
          this.$toast.error(res.data.msg);
        }

      });
    },
    //翻页
    pageAvailableData(v) {
      this.assets_list.active = false;

      this.assets_list.current = v;
      this.getinventory({
        current: this.assets_list.current,
        size: this.assets_list.size,
      });
    },
    //确认取回
    decorationsFunction() {
      userRedeem({ lstmSerial: this.activeList }).then((res) => {
        if (res.data.code == 0) {
          this.switch_tradeofferbox_show(true);
          //this.$toast.success(res.data.msg);
          this.pageAvailableData(1);
        } else {
          this.$toast.error(res.data.msg);
        }
      });
    },
    pinItem(togglePin) {
      api_PinItem({ lstmSerial: this.activeList, togglePin: togglePin }).then((res) => {
        if (res.data.code === 0) {
          this.assets_list.active = false;
          this.$toast.success(res.data.msg);
          this.$store.commit("setInfo");
          this.pageAvailableData(1);
        } else {
          this.$toast.error(res.data.msg);
        }
      });
    },
    async searchTransferUser() {
      const uid = String(this.visibleSubAccount.uid || '').trim();
      if (!uid) {
        this.$toast.error('请输入对方的UID');
        return;
      }
      if (this.visibleSubAccount.searching) {
        return;
      }
      this.visibleSubAccount.searching = true;
      this.visibleSubAccount.subProfile = null;
      this.visibleSubAccount.searchedUid = "";
      try {
        const res = await api_GetSubProfileByUid({ uid });
        if (res.data.code === 0) {
          this.visibleSubAccount.subProfile = res.data.data;
          this.visibleSubAccount.searchedUid = uid;
        } else {
          this.$toast.error(res.data.msg);
        }
      } catch (error) {
        this.$toast.error('搜索用户失败，请稍后再试');
      } finally {
        this.visibleSubAccount.searching = false;
      }
    },
    handleTransferAction() {
      if (this.visibleSubAccount.searching) {
        return;
      }
      if (this.canTransferToTarget) {
        this.fetchTransfer();
        return;
      }
      this.searchTransferUser();
    },
    fetchTransfer() {
      const uid = String(this.visibleSubAccount.uid || '').trim();
      if (!uid) {
        this.$toast.error('请输入对方的UID');
        return;
      }
      if (!this.canTransferToTarget) {
        this.$toast.error('请先搜索并确认赠送对象');
        return;
      }
      api_Transfer({ itemSerialLst: this.activeList, uid: uid, skipReview: true }).then(res => {
        if (res.data.code == 0) {
          this.$toast.success('转移成功');
          this.visibleSubAccount.flag = false;
          this.visibleSubAccount.uid = "";
          this.visibleSubAccount.subProfile = null;
          this.visibleSubAccount.searchedUid = "";
          this.pageAvailableData(1)
        } else {
          this.$toast.error(res.data.msg);
        }
      })
    },
    async getSubAccount() {
      const res = await api_GetSubAccount();
      this.subAccountList = res.data.data
    },
  },
  computed: {
    ...mapState([
      "user", 'sellSound', 'isMute'
    ]),
    activeList() {
      var arr = this.assets_list.data.list
        .filter((item) => item.active == true)
        .map((item) => item.mSerial);
      return arr;
    },
    //计算选中数量
    mynum() {
      let arr = this.assets_list.data.list.filter((item) => {
        return item.active;
      });
      return arr.length;
    },
    //计算价钱
    mysum() {
      let arr = this.assets_list.data.list.filter((item) => {
        return item.active;
      });
      return arr.reduce((a, b) => {
        return a + b.price;
      }, 0);
    },
    transferTargetName() {
      const profile = this.visibleSubAccount.subProfile || {};
      return profile.name || profile.nickname || profile.userName || '未设置昵称';
    },
    canTransferToTarget() {
      const uid = String(this.visibleSubAccount.uid || '').trim();
      return !!uid && !!this.visibleSubAccount.subProfile && this.visibleSubAccount.searchedUid === uid;
    },
    transferButtonText() {
      if (this.visibleSubAccount.searching) {
        return '搜索中';
      }
      return this.canTransferToTarget ? '确定' : '搜索';
    },
  },
  watch: {
    'visibleSubAccount.uid'(value) {
      const uid = String(value || '').trim();
      if (this.visibleSubAccount.searchedUid && this.visibleSubAccount.searchedUid !== uid) {
        this.visibleSubAccount.subProfile = null;
        this.visibleSubAccount.searchedUid = "";
      }
    },
    $route() {
      // console.log(1);
    },
  },
};
